exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-container[data-v-2ab67e52]{display:flex;flex-direction:column}#loading[data-v-2ab67e52]{flex:0 1 auto}#creating[data-v-2ab67e52],#map[data-v-2ab67e52]{flex:1 1 auto}#legend[data-v-2ab67e52]{flex:0 1 auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2ab67e52","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Site/Map.vue
// module id = 388
// module chunks = 0